import { render } from "./AddUserAdmin.vue?vue&type=template&id=aec71b18"
import script from "./AddUserAdmin.vue?vue&type=script&lang=js"
export * from "./AddUserAdmin.vue?vue&type=script&lang=js"

import "./AddUserAdmin.vue?vue&type=style&index=0&id=aec71b18&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__